import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import HomeJunctionListingStatusAppResource from "./HomeJunctionListingStatusAppResource";

export const NONE = 'ba12bd4d-6c81-4968-94da-f54d7a96942d';
export const ACTIVE = 'e78c6fad-333f-4564-a762-091d9b9f9dfd';
export const PENDING_AND_UNDER_CONTRACT = 'f6389838-ba97-4e4a-b9c4-8f54a4cc5b52';

export const ALL = {
    NONE,
    ACTIVE,
    PENDING_AND_UNDER_CONTRACT,
};

class LuListingStatusAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'lu-listing-status';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'lus/listings/statuses';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'slug',
            'title',
            'description',
            'meta',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            homeJunctionListingStatuses: HomeJunctionListingStatusAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return [];
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            slug: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            title: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            description: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
            meta: {
                type: 'array'
            },
        };
    }

}

export default LuListingStatusAppResource;
